<div class="reducao-carencia-container">
  <h3 class="titulo text-center bold-preto-700 mb-3">{{ titulo }}</h3>
  <table class="table table-bordered">
    <thead>
      <tr>
        <th class="w-h" style="background: #ccc">GRUPO DE CARÊNCIA</th>
        <th class="w-h" style="background: #ccc; width: 14% !important">COBERTURA</th>
        <th class="w-m" style="background: #ccc">PRAZO DE CARÊNCIA CONTRATUAIS</th>
        <th class="w-h" style="background: #ccc">CARÊNCIA REDUÇÃO</th>
      </tr>
    </thead>
    <tbody>
      <!-- Grupo I -->
      <tr>
        <td>I</td>
        <td>Urgência, Emergência e Acidente Pessoal</td>
        <td>24(Vinte e quatro) horas.</td>
        <td>24(Vinte e quatro) horas.</td>
      </tr>
      <!-- Grupo II -->
      <tr>
        <td>II</td>
        <td>Consultas Médicas</td>
        <td>30 (Trinta) dias</td>
        <td>24(Vinte e quatro) horas.</td>
      </tr>
      <!-- Grupo III -->
      <tr>
        <td>III</td>
        <td>Exames simples: Exames simples radiografias, laboratório e eletrocardiograma</td>
        <td>30 (Trinta) dias</td>
        <td>24(Vinte e quatro) horas.</td>
      </tr>
      <!-- Grupo IV -->
      <tr>
        <td>IV</td>
        <td>
          Exames e Procedimentos Complexos I: Exames de laboratório - biologia molecular,imunológicos e
          hormonais;radiografias contratadas;ultrassom simples;mamografia;teste ergometrico.
        </td>
        <td>90(noventa) dias</td>
        <td>24(Vinte e quatro) horas.</td>
      </tr>
      <!-- Grupo V -->
      <tr>
        <td>V</td>
        <td>Exames e Procedimentos Complexos II: teste alérgico, densitometria</td>
        <td>120 (cento e vinte)dias</td>
        <td>90(noventa) dias</td>
      </tr>
      <!-- Grupo VI -->
      <tr>
        <td>VI</td>
        <td>
          Exames e Procedimentos Especiais: Endoscopia intervencionista e diagnósticas; ultrassonografia
          intervencionista; holter; mapa; ultrassonografia diagnóstica com doppler; ecocardiograma com doppler; pequena
          cirurgia ambulatorial de porte anestésico zero; exames e testes específicos; eletrofisiológicos funcionais.
        </td>
        <td>180 (cento e oitenta) dias.</td>
        <td>90 (noventa).</td>
      </tr>
      <!-- Grupo VII -->
      <tr>
        <td>VII</td>
        <td>
          Fisioterapias: Fisioterapias, fonoterapia, acupuntura; e demais terapias; exceto as ligadas à saúde mental.
        </td>
        <td>180 (cento e oitenta) dias</td>
        <td>90 (noventa) dias.</td>
      </tr>
      <!-- Grupo VIII -->
      <tr>
        <td>VIII</td>
        <td>
          Exames e Procedimentos de Alta Complexidade: Ressonância magnética nuclear; hemodinâmica, hemoterapia,
          radioterapia; hemodiálise de curta ou longa duração, quimioterapia; tomografia computadorizada; exames e
          procedimentos de medicina nuclear e demais exames e procedimentos cobertos por este contrato e não
          especificados nos grupos anteriores.
        </td>
        <td>180 (cento e oitenta) dias</td>
        <td>180 (cento e oitenta) dias</td>
      </tr>
      <!-- Grupo IX -->
      <tr>
        <td>IX</td>
        <td>Saúde Mental: Atendimento à Saúde Mental ambulatorial.</td>
         <td>180 (cento e oitenta) dias</td>
         <td>180 (cento e oitenta) dias</td>
      </tr>
      <!-- Grupo X -->
      <tr>
        <td>X</td>
        <td>Internações Clínicas, Cirúrgicas e UTI</td>
        <td>180 (cento e oitenta) dias</td>
        <td>180 (cento e oitenta) dias</td>
      </tr>
      <!-- Grupo XI -->
      <tr>
        <td>XI</td>
        <td>Internações Psiquiátricas.</td>
        <td>180 (cento e oitenta) dias</td>
        <td>180 (cento e oitenta) dias</td>
      </tr>
      <!-- Grupo XII -->
      <tr>
        <td>XII</td>
        <td>Doenças e lesões preexistentes com opção de Cobertura Parcial Temporária - CPT.</td>
        <td>24 (vinte e quatro) meses.</td>
        <td>24 (vinte e quatro) meses.</td>
      </tr>
    </tbody>
  </table>
</div>
